import type React from 'react'

export const isKeyboardActivation = (event: React.KeyboardEvent) =>
  event.key === 'Enter' || event.key === ' '

export const activateOnKeyboard = (event: React.KeyboardEvent, onActivate: () => void) => {
  if (!isKeyboardActivation(event)) return

  event.preventDefault()
  onActivate()
}

export const stopKeyboardActivationPropagation = (event: React.KeyboardEvent) => {
  if (isKeyboardActivation(event)) {
    event.stopPropagation()
  }
}
